var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21.0001C5.30622 21.0001 6.41746 20.1653 6.82929 19.0001H15.5C17.9853 19.0001 20 16.9854 20 14.5001 20 12.0148 17.9853 10.0001 15.5 10.0001H4.5C3.11929 10.0001 2 8.88079 2 7.50008 2 6.11936 3.11929 5.00008 4.5 5.00008H7.58579L6.29289 6.29297 7.70711 7.70718 11.4142 4.00008 7.70711.292969 6.29289 1.70718 7.58579 3.00008H4.5C2.01472 3.00008.0 5.01479.0 7.50008.0 9.98536 2.01472 12.0001 4.5 12.0001h11C16.8807 12.0001 18 13.1194 18 14.5001 18 15.8808 16.8807 17.0001 15.5 17.0001H6.82929C6.41746 15.8349 5.30622 15.0001 4 15.0001 2.34315 15.0001 1 16.3432 1 18.0001c0 1.6568000000000005 1.34315 3 3 3zm-1-3C3 17.4478 3.44772 17.0001 4 17.0001 4.55228 17.0001 5 17.4478 5 18.0001 5 18.5524 4.55228 19.0001 4 19.0001 3.44772 19.0001 3 18.5524 3 18.0001zM16 1.00008C17.6569 1.00008 19 2.34322 19 4.00008 19 5.65693 17.6569 7.00008 16 7.00008 14.3431 7.00008 13 5.65693 13 4.00008 13 2.34322 14.3431 1.00008 16 1.00008zM15 4.00008C15 3.44779 15.4477 3.00008 16 3.00008 16.5523 3.00008 17 3.44779 17 4.00008 17 4.55236 16.5523 5.00008 16 5.00008 15.4477 5.00008 15 4.55236 15 4.00008z",
    fill: "url(#paint0_linear_7438_3980)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7438_3980",
    x1: -11.5,
    y1: -0.140309,
    x2: -11.5,
    y2: 17.3713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016dff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/location-blue.5347f134.svg";
export { ForwardRef as ReactComponent };